module.exports = __webpack_public_path__ + "img/prideSwag.a6c8efdc.svg";